/**
 * Copie un texte dans le presse-papier — avec repli. Mirroir de
 * `apps/app/src/lib/clipboard.ts` (petite fonction pure, dupliquée plutôt que
 * de faire dépendre `packages/visio` d'`apps/app`).
 *
 * `navigator.clipboard.writeText` est REFUSÉ quand le « geste utilisateur » du
 * clic est perdu (Safari le perd dès qu'un `await` réseau s'intercale) ou hors
 * contexte sécurisé. Le repli `document.execCommand('copy')` sur un
 * `<textarea>` temporaire couvre ces cas. Ne lève jamais.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // refusé (geste perdu, permission, contexte non sécurisé) → repli ci-dessous
  }
  return legacyCopy(text);
}

function legacyCopy(text: string): boolean {
  if (typeof document === 'undefined') return false;
  const el = document.createElement('textarea');
  try {
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px';
    document.body.appendChild(el);
    el.select();
    el.setSelectionRange(0, text.length);
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    el.remove();
  }
}
